import React from 'react';
import { CardData } from 'types/story';
import { Context, ISelectionHintContext } from 'client/components/common/SelectionHint/SelectionHintContext';
import { TRAVERSE_TREE_TARGETS } from 'client/components/common/BuildingBlocks/utils/common';
import { StoryFacade } from 'common/utils/facades/story-facade';
import Card from './Card';

type Props = {
	data: CardData;
	story: StoryFacade;
};

class CardEditable extends React.Component<Props> {
	static contextType = Context;
	context: React.ContextType<typeof Context>;

	get treeOptions() {
		const context = this.context as ISelectionHintContext['editor'];

		return {
			target: TRAVERSE_TREE_TARGETS.EDITOR,
			isCardTree: true,
			onMouseDown: context.treeOptions.onMouseDown,
			onFocus: context.treeOptions.onFocus,
			onMouseEnter: context.treeOptions.onMouseEnter,
			onMouseLeave: context.treeOptions.onMouseLeave,
			onMouseDownCapture: context.treeOptions.onMouseDownCapture,
			onDoubleClickCapture: context.treeOptions.onDoubleClickCapture,
		} as const;
	}

	onCardClick = e => {};

	render() {
		return (
			<Card
				card={this.props.data}
				treeOptions={this.treeOptions}
				onCardClick={this.onCardClick}
				isEditor
				story={this.props.story}
			/>
		);
	}
}

export default CardEditable;
